import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../components/CustomFormsComponents/CustomField';

const useSuspendAvisoObraFieldsConfig = ({
    t,
    formData,
    handleBlurValidation,
    selectedObra
}: any) => {
    const [fieldsConfig, setFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const fechaInicioObra = selectedObra?.fechaInicio
            ? new Date(selectedObra.fechaInicio)
            : null;
        const fechaFinObra = selectedObra?.fechaFin ? new Date(selectedObra.fechaFin) : null;

        const fieldsConfig: FieldConfig[] = [
            {
                type: 'date-mui',
                label: t('avisoObraForms.suspend.inputs.suspensionDate') as string,
                name: 'suspensionDate',
                required: true,
                value: formData.suspensionDate,
                disabled: false,
                helperText:
                    fechaInicioObra && fechaFinObra
                        ? `Debe estar entre ${fechaInicioObra.toLocaleDateString(
                              'es-AR'
                          )} y ${fechaFinObra.toLocaleDateString('es-AR')}`
                        : t('avisoObraForms.suspend.inputs.suspensionDate'),
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }],
                minDate: fechaInicioObra?.toISOString(),
                maxDate: fechaFinObra?.toISOString()
            },
            {
                type: 'text',
                label: t('avisoObraForms.suspend.inputs.motive') as string,
                name: 'motive',
                required: true,
                value: formData.motive,
                disabled: false,
                helperText: t('avisoObraForms.suspend.inputs.motive') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }]
            }
        ];

        setFieldsConfig(fieldsConfig);
    }, [t, selectedObra]);

    return {
        fieldsConfig
    };
};

export default useSuspendAvisoObraFieldsConfig;
